export enum MeasureType {
    WORKING_TIME = 'working_time',
    WEIGHT = 'weight',
    VOLUME = 'volume',
    LENGTH = 'length',
    DISTANCE = 'distance'
}
